
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PartyBalanceGrid extends Serenity.EntityGrid<PartyBalanceRow, any> {
        protected getColumnsKey() { return 'Finance.PartyBalance'; }
        protected getDialogType() { return PartyBalanceDialog; }
        protected getIdProperty() { return PartyBalanceRow.idProperty; }
        protected getInsertPermission() { return PartyBalanceRow.insertPermission; }
        protected getLocalTextPrefix() { return PartyBalanceRow.localTextPrefix; }
        protected getService() { return PartyBalanceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}